// eslint-disable-next-line jira/restricted/react
import React, { PureComponent, type SyntheticEvent } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import AkButton from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { styledComponentWithCondition } from '@atlassian/jira-compiled-migration';
import { ff } from '@atlassian/jira-feature-flagging';
import { type IntlShapeV2 as IntlShape, injectIntlV2 as injectIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { layout } from '../../../common/constants/styles';
import clearDoneIssuesMessages from './messages';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContainerControl = styled.div({
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${layout.gutter}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContainerExperiment = styled2.div({
	textAlign: 'center',
	padding: token('space.100', '8px'),
});

const Container = styledComponentWithCondition(
	() => ff('compiled.migration.jsw.tanuki'),
	ContainerExperiment,
	ContainerControl,
);

type Props = {
	url: string;
	isCMPBoard?: boolean;
	onClick: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
export class DoneCardsButton extends PureComponent<Props> {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onClick = (e: SyntheticEvent<any>, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'findClearedIssues');
		this.props.onClick();
	};

	renderButton = (intl: IntlShape) => {
		const message = intl.formatMessage(
			this.props.isCMPBoard
				? clearDoneIssuesMessages.oldIssuesSearchLink
				: clearDoneIssuesMessages.findDoneClearedCardsLink,
		);

		return (
			<AkButton
				appearance="subtle"
				spacing="compact"
				href={this.props.url}
				onClick={this.onClick}
				iconBefore={<SearchIcon label="" size="small" />}
			>
				{message}
			</AkButton>
		);
	};

	render = () => {
		const { intl } = this.props;
		return (
			<Container>
				<Tooltip
					content={intl.formatMessage(
						this.props.isCMPBoard
							? clearDoneIssuesMessages.oldIssuesSearchMessage
							: clearDoneIssuesMessages.doneClearedCardsTooltip,
					)}
				>
					{this.renderButton(intl)}
				</Tooltip>
			</Container>
		);
	};
}

export default injectIntl(DoneCardsButton);
